import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { GameReponseType } from "magic-shared-types";

interface GlobalState {
  token: string;
  game: GameReponseType;
  email: string;
  jwtToken: string;
}

const initialState: GlobalState = {
  token: "",
  game: {
    id: 1,
    display_name: "Magic: the Gathering",
    name: "Magic",
    card_trader_game: "mtg",
    card_market_game: "Magic",
  },
  email: "",
  jwtToken: "",
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setAddToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setGame(state, action: PayloadAction<GameReponseType>) {
      state.game = action.payload;
    },
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    setJwtToken(state, action: PayloadAction<string>) {
      state.jwtToken = action.payload;
    },
  },
});

export const selectToken = (state: RootState) => state.global.token;
export const selectJwtToken = (state: RootState) => state.global.jwtToken;
export const selectGame = (state: RootState) => state.global.game;
export const selectEmail = (state: RootState) => state.global.email;
export const { setAddToken, setGame, setEmail, setJwtToken } =
  globalSlice.actions;
export default globalSlice.reducer;
